import { render } from "./FooterMenu.vue?vue&type=template&id=6f227bbb&scoped=true"
const script = {}

import "./FooterMenu.vue?vue&type=style&index=0&id=6f227bbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f227bbb"]])

export default __exports__